import script from "./activityManage.vue?vue&type=script&setup=true&lang=js"
export * from "./activityManage.vue?vue&type=script&setup=true&lang=js"

import "./activityManage.vue?vue&type=style&index=0&id=5f69806c&lang=scss"

const __exports__ = script;

export default __exports__